import { render, staticRenderFns } from "./PolicyCardProtection.vue?vue&type=template&id=fdc88c16&"
import script from "./PolicyCardProtection.vue?vue&type=script&lang=ts&"
export * from "./PolicyCardProtection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports